module.exports = __webpack_public_path__ + "assets/img/uesrIcon3.86bbcd4c.png";